import { toast } from "react-toastify";

export const Notify = (text, type) => toast(text, {type});
